/*
  NOTE: This hook doesn't use IntersectionObserver, since I think it pre-dates it. I should probably use `useIsOnscreen` instead, unless I need really-fine-grained control over the specific ratio at every moment in time.
*/

import React from 'react';

import { throttle, clamp } from '@/utils';

export default function useIntersectionRatio(
  elementRef: React.RefObject<HTMLElement>,
  throttleBy: number = 25
) {
  const [ratio, setRatio] = React.useState(0);

  React.useEffect(() => {
    if (!elementRef.current) {
      return;
    }

    const handleScroll = throttle(() => {
      if (!elementRef.current) {
        return;
      }

      const bb = elementRef.current.getBoundingClientRect();

      const rawRatio = 1 - bb.top / window.innerHeight;
      setRatio(clamp(rawRatio));
    }, throttleBy);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [elementRef, throttleBy]);

  return ratio;
}
